import React, { useEffect, useState } from 'react';
import { ArrowLeft2, ArrowRight2 } from 'iconsax-react';
import { TIPO, apiToViewEvento, toDateKey } from './mockData';

const GIORNI_SHORT = ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'];
const MESI_ITA     = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];
const MESI_SHORT   = ['Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'];

const HOUR_H     = 90;
const TIME_W     = 82;
const PX_PER_MIN = HOUR_H / 60;
const H_START    = 7;
const H_END      = 21;

function timeToMin(t) { const [h, m] = t.split(':').map(Number); return h * 60 + m; }

function getMonday(date) {
    const d = new Date(date);
    const day = d.getDay();
    d.setDate(d.getDate() + (day === 0 ? -6 : 1 - day));
    d.setHours(0, 0, 0, 0);
    return d;
}

function formatRange(monday) {
    const sunday = new Date(monday);
    sunday.setDate(sunday.getDate() + 6);
    const d1 = monday.getDate(), d2 = sunday.getDate();
    const m1 = MESI_ITA[monday.getMonth()], m2 = MESI_ITA[sunday.getMonth()];
    const y  = sunday.getFullYear();
    return monday.getMonth() === sunday.getMonth() ? `${d1}-${d2} ${m1} ${y}` : `${d1} ${m1} – ${d2} ${m2} ${y}`;
}

function PagatoBadge({ pagato }) {
    if (pagato) return <span style={{ fontSize: 10, fontWeight: 600, background: '#00A15D', color: '#fff', borderRadius: 3, padding: '1px 6px', whiteSpace: 'nowrap' }}>Pagato</span>;
    return <span style={{ fontSize: 10, fontWeight: 600, background: 'rgba(255,94,75,0.08)', color: '#FF5E4B', border: '1px solid rgba(255,94,75,0.35)', borderRadius: 3, padding: '1px 6px', whiteSpace: 'nowrap' }}>Non pagato</span>;
}

function SettCard({ event, top, height, leftPct, widthPct, onEventClick }) {
    const t = TIPO[event.type] || TIPO.generico;
    const h = Math.max(height, 40);
    return (
        <div
            style={{ position: 'absolute', top, height: h, left: `calc(${leftPct}% + 3px)`, width: `calc(${widthPct}% - 6px)`, background: '#fff', borderTop: `3px solid ${t.color}`, border: `1px solid ${t.color}22`, borderTopWidth: 3, borderTopColor: t.color, borderRadius: '0 0 4px 4px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', padding: '4px 7px', overflow: 'hidden', cursor: 'pointer', zIndex: 1, transition: 'box-shadow 0.15s' }}
            onClick={() => onEventClick && onEventClick(event)}
            onMouseEnter={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.14)'}
            onMouseLeave={e => e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.07)'}
        >
            <div style={{ fontSize: 12, fontWeight: 700, color: '#1a1a1a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{event.titolo}</div>
            {h >= 58 && <div style={{ fontSize: 11, color: '#999', marginTop: 1 }}>{event.oraInizio} – {event.oraFine}</div>}
            {h >= 72 && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 5, flexWrap: 'wrap' }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: 10, color: '#aaa', border: '1px solid #e8e8e8', borderRadius: 3, padding: '1px 5px', background: '#fafafa' }}>
                        <span style={{ width: 6, height: 6, borderRadius: '50%', border: '1.5px solid #ccc', display: 'inline-block' }} />{event.type === 'generico' ? 'Generico' : (event.tipologia || '—')}
                    </span>
                    {event.type !== 'generico' && <PagatoBadge pagato={event.pagato} />}
                </div>
            )}
        </div>
    );
}

function layoutEvents(eventi) {
    const sorted = [...eventi].sort((a, b) => timeToMin(a.oraInizio) - timeToMin(b.oraInizio));
    const result = [], groups = [];
    sorted.forEach(ev => {
        const s = timeToMin(ev.oraInizio), e = timeToMin(ev.oraFine);
        let placed = false;
        for (const group of groups) {
            if (s < Math.max(...group.map(g => timeToMin(g.ev.oraFine)))) {
                group.push({ ev, s, e }); placed = true; break;
            }
        }
        if (!placed) groups.push([{ ev, s, e }]);
    });
    groups.forEach(group => {
        const cols = [];
        group.forEach(item => {
            let col = 0;
            while (cols[col] && cols[col] > item.s) col++;
            cols[col] = item.e;
            result.push({ ...item, col, totalCols: group.length });
        });
    });
    return result;
}

function DayColumn({ eventi, onEventClick }) {
    const startMin = H_START * 60;
    const totalH   = (H_END - H_START) * HOUR_H;
    const laid     = layoutEvents(eventi);
    return (
        <div style={{ position: 'relative', height: totalH, borderLeft: '1px solid #f0f0f0', flex: 1, minWidth: 0 }}>
            {Array.from({ length: H_END - H_START + 1 }, (_, i) => (
                <div key={i} style={{ position: 'absolute', left: 0, right: 0, top: i * HOUR_H, height: 1, background: '#f4f4f4' }} />
            ))}
            {laid.map(({ ev, s, e, col, totalCols }) => (
                <SettCard key={ev.id} event={ev}
                    top={(s - startMin) * PX_PER_MIN}
                    height={(e - s) * PX_PER_MIN}
                    leftPct={col * (100 / totalCols)}
                    widthPct={100 / totalCols}
                    onEventClick={onEventClick}
                />
            ))}
        </div>
    );
}

export default function VistaSettimana({ eventi = [], onRangeChange, onEventClick, onDayClick }) {
    const [weekStart, setWeekStart] = useState(getMonday(new Date()));

    const days = Array.from({ length: 7 }, (_, i) => {
        const d = new Date(weekStart); d.setDate(d.getDate() + i); return d;
    });

    useEffect(() => {
        const sunday = new Date(weekStart); sunday.setDate(sunday.getDate() + 6);
        const da = `${toDateKey(weekStart)}T00:00:00`;
        const a  = `${toDateKey(sunday)}T23:59:59`;
        onRangeChange && onRangeChange(da, a);
    }, [weekStart]); // eslint-disable-line react-hooks/exhaustive-deps

    const onNav = (dir) => {
        const d = new Date(weekStart); d.setDate(d.getDate() + dir * 7); setWeekStart(d);
    };

    // Trasforma e raggruppa per giorno (date string)
    const byDay = {};
    days.forEach(d => { byDay[toDateKey(d)] = []; });
    (eventi || []).forEach(ev => {
        const key = ev.dataInizio.substring(0, 10);
        if (byDay[key]) byDay[key].push(apiToViewEvento(ev));
    });

    const hours = Array.from({ length: H_END - H_START }, (_, i) => {
        const h = H_START + i;
        return `${String(h).padStart(2, '0')}:00`;
    });

    const btnBase = { width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e0e0e0', borderRadius: 4, background: '#fff', cursor: 'pointer' };
    const today = new Date();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 24px', borderBottom: '1px solid #f0f0f0', flexShrink: 0, flexWrap: 'wrap', gap: 8 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 18, flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 17, fontWeight: 700, color: '#222' }}>{formatRange(weekStart)}</span>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                        {Object.entries(TIPO).map(([k, t]) => (
                            <span key={k} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: '#555' }}>
                                <span style={{ width: 8, height: 8, borderRadius: '50%', background: t.color, display: 'inline-block' }} />{t.label}
                            </span>
                        ))}
                    </div>
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={() => onNav(-1)} style={btnBase}><ArrowLeft2  size={14} color="#555" /></button>
                    <button onClick={() => onNav(1)}  style={btnBase}><ArrowRight2 size={14} color="#555" /></button>
                </div>
            </div>

            <div style={{ display: 'flex', borderBottom: '1px solid #f0f0f0', flexShrink: 0 }}>
                <div style={{ width: TIME_W, flexShrink: 0 }} />
                {days.map((d, i) => {
                    const isToday = d.toDateString() === today.toDateString();
                    return (
                        <div key={i} style={{ flex: 1, textAlign: 'center', padding: '8px 4px', borderLeft: '1px solid #f0f0f0' }}>
                            <div style={{ fontSize: 10, color: '#bbb', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 2 }}>{MESI_SHORT[d.getMonth()]}</div>
                            <div
                                onClick={() => onDayClick && onDayClick(new Date(d))}
                                title="Vai al giorno"
                                style={{ fontSize: 20, fontWeight: 800, lineHeight: 1, color: isToday ? '#fff' : '#222', background: isToday ? '#FF5E4B' : 'transparent', borderRadius: '50%', width: 32, height: 32, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                            >{d.getDate()}</div>
                            <div style={{ fontSize: 10, color: '#bbb', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, marginTop: 2 }}>{GIORNI_SHORT[d.getDay()]}</div>
                        </div>
                    );
                })}
            </div>

            <div style={{ flex: 1, overflowY: 'auto', display: 'flex' }}>
                <div style={{ width: TIME_W, flexShrink: 0 }}>
                    {hours.map((h, i) => (
                        <div key={i} style={{ height: HOUR_H, display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end', paddingTop: 6, paddingRight: 10, fontSize: 11, color: '#c0c0c0', fontWeight: 500, whiteSpace: 'nowrap' }}>{h}</div>
                    ))}
                </div>
                <div style={{ flex: 1, display: 'flex', minWidth: 0 }}>
                    {days.map((d, i) => (
                        <DayColumn key={i} eventi={byDay[toDateKey(d)] || []} onEventClick={onEventClick} />
                    ))}
                </div>
            </div>
        </div>
    );
}
